import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RouterLink from 'react-router/lib/Link';
import { PAYMENT_FEE_SINGLE, QUERY_SELECTED_HARDWARE } from '../../../helpers/constants';
import suitcss from '../../../helpers/suitcss';
import connectUI from '../../basics/ui/UIConnector';
import { bindQueryParams } from '../../../helpers/url';

import { getTariffHardwareRelation } from '../../../helpers/entity';
import { shape as hardwareShape } from '../../../propTypes/hardware';
import { imageShape } from '../../../propTypes/media';
import imageSizes from '../../../config/imageSizes';

import MediaImage from '../../basics/media/MediaImage';
import Link from '../../basics/text/TextLink';
import Copy from '../../basics/text/TextCopy';
import Callout from '../../../containers/callout/Callout';
import MediaImageBackground from '../../basics/media/MediaImageBackground';

import HardwarePaymentUnit from '../../../containers/hardware/HardwarePaymentUnit';
import Tag from '../../basics/text/Tag';
import TextRaw from '../../basics/text/TextRaw';

class HeaderItemHardware extends PureComponent {

  renderPrices() {
    const { featured, hardware, ui } = this.props;
    return (
      <div
        className={suitcss({
          componentName: 'HeaderStageItem',
          descendantName: 'singlePaymentFee',
        })}
      >
        <HardwarePaymentUnit
          hardware={hardware}
          paymentType={PAYMENT_FEE_SINGLE}
          postfix={ui.guiWordSingularAbbr}
          size={featured ? 'm' : 's'}
        />
      </div>
    );
  }

  render() {
    const { copy, image, hardware, link, featured, ui, isNew } = this.props;
    // TODO Remove quick fix once Tariff Relation is ensured
    const tariffRelation = hardware.cheapestHardwareWithTariff &&
      getTariffHardwareRelation(hardware);
    const linkTo = link || {
      title: ui.guiWordDetails,
      url: bindQueryParams(hardware.urlDetails, {
        [QUERY_SELECTED_HARDWARE]: hardware.eid,
      }),
    };
    const hardwareImage = {
      ...hardware.image,
      sizes: imageSizes[featured ? 'headerItemFeatured' : 'headerItem'],
    };
    const backgroundImage = {
      ...image,
      sizes: imageSizes[featured ? 'headerItemBackgroundFeatured' : 'headerItemBackground'],
    };
    return (
      <MediaImageBackground
        className={suitcss({
          componentName: 'HeaderStageItem',
          modifiers: [
            'typeHardware',
            featured && 'featured',
          ],
        })}
        {...backgroundImage}
        isLazy
      >
        {!featured && (
          <RouterLink
            className={suitcss({
              componentName: 'HeaderStageItem',
              descendantName: 'ctaOverlay',
            })}
            to={linkTo.url}
            target={linkTo.target}
          />
        )}
        <div
          className={suitcss({
            componentName: 'HeaderStageItem',
            descendantName: 'inner',
          })}
        >
          <div
            className={suitcss({
              componentName: 'HeaderStageItem',
              descendantName: 'image',
            })}
          >
            <MediaImage {...hardwareImage} isLazy />
          </div>
          <div
            className={suitcss({
              componentName: 'HeaderStageItem',
              descendantName: 'content',
            })}
          >
            {!featured && tariffRelation && this.renderPrices()}
            <div
              className={suitcss({
                componentName: 'HeaderStageItem',
                descendantName: 'copy',
              })}
            >
              <Copy embedded inverted >
                <TextRaw
                  className={suitcss({
                    componentName: 'HeaderStageItem',
                    descendantName: 'headline',
                    utilities: ['inline'],
                  })}
                >
                  {copy}
                </TextRaw>
                {isNew &&
                  <React.Fragment>
                    &nbsp;
                    <Tag theme="tertiary" label={ui.guiWordNew} />
                  </React.Fragment>
                }
              </Copy>
            </div>
            {featured && (
              <div
                className={suitcss({
                  componentName: 'HeaderStageItem',
                  descendantName: 'subcontent',
                })}
              >
                {tariffRelation && this.renderPrices()}
                <div
                  className={suitcss({
                    componentName: 'HeaderStageItem',
                    descendantName: 'link',
                  })}
                >
                  <Link
                    to={linkTo.url}
                    asButton
                    buttonFilled
                    target={linkTo.target}
                  >
                    {linkTo.title}
                  </Link>
                </div>
              </div>
            )}
          </div>
          <Callout
            theme="badge"
            targets={[hardware.eid, hardware.groupId]}
            inverted
          />
        </div>
      </MediaImageBackground>
    );
  }
}

HeaderItemHardware.propTypes = {
  copy: PropTypes.string,
  link: PropTypes.object,
  image: imageShape,
  hardware: hardwareShape.isRequired,
  featured: PropTypes.bool,
  ui: PropTypes.shape({
    guiWordDetails: PropTypes.string.isRequired,
    guiWordSingularAbbr: PropTypes.string.isRequired,
  }),
  isNew: PropTypes.bool,
};

HeaderItemHardware.defaultProps = {};

export default connectUI()(HeaderItemHardware);
